import { useCallback, useState } from 'react';

import AppliedFiltersPanel from 'components/TrackmanEvents/AppliedFiltersPanel/AppliedFiltersPanel';
import EventTile from 'components/TrackmanEvents/EventTile/EventTile';
import EventTileSkeleton from 'components/TrackmanEvents/EventTileSkeleton/EventTileSkeleton';
import EventsFiltersPanel from 'components/TrackmanEvents/EventsFiltersPanel/EventsFiltersPanel';
import { ReactComponent as FilterIcon } from 'images/icons/Filter.svg';
import Paragraph from 'components/TextComps/Paragraph';
import Subtitle from 'components/TextComps/Subtitle';
import { TrackmanEventFiltersType } from 'types/trackmanEvents';
import YouTubeVideoModal from 'components/TrackmanEvents/YouTubeVideoModal/YouTubeVideoModal';
import { filterConfig } from '../../../pages/TrackmanEvents/filterConfig';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

export const OnDemandRecordings = observer(() => {
  const tes = useStores().trackmanEventsStore;
  const [isFiltersVisible, setIsFiltersVisible] = useState(false);
  const [isModalOn, setIsModalOn] = useState(false);
  const [modalData, setModalData] = useState({ videoId: '', videoLabel: '' });
  const { t } = useTranslation();

  const onFilterClick = useCallback(
    (isSelected: boolean, label: string, filter: TrackmanEventFiltersType) => {
      if (!isSelected) {
        tes.addFilterToList(label, filter);
      } else {
        tes.removeFilterFromList(label, filter);
      }
      tes.filteredOnDemandEventsList = tes.filterEvents(tes.onDemandEventsList);
    },
    [tes]
  );

  const onClearFilters = useCallback(() => {
    tes.clearFilters();
  }, [tes]);

  const onApplyFilters = useCallback(() => {
    setIsFiltersVisible(false);
  }, []);

  return (
    <div className={`events-subpage ${isFiltersVisible ? 'filters-visible' : ''}`}>
      {isFiltersVisible ? <div className='filters-background' onClick={() => setIsFiltersVisible(false)} /> : null}
      <div className='page-heading'>
        <Subtitle>
          <>{t('OnDemandRecordings', { ns: 'trackmanEvents' })}</>
        </Subtitle>
        {tes.onDemandEventsList.length && !isFiltersVisible ? (
          <div className='filters-button' onClick={() => setIsFiltersVisible(!isFiltersVisible)}>
            <FilterIcon /> <span>{t('Filter', { ns: 'trackmanEvents' })}</span>
          </div>
        ) : null}
      </div>
      {Object.keys(tes.eventFilters).length ? (
        <div className='applied-filters-bar'>
          <AppliedFiltersPanel onFilterClick={onFilterClick} />
        </div>
      ) : null}
      <div className='events-list'>
        {tes.filteredOnDemandEventsList.length ? (
          tes.filteredOnDemandEventsList.map((event, i: number) => {
            return !event.id ? (
              <EventTileSkeleton key={`${event.title}+${i}-skeleton`} delay={i * 50} />
            ) : (
              <EventTile key={`${event.title}+${i}`} eventItem={event} setIsModalOn={setIsModalOn} setModalData={setModalData} />
            );
          })
        ) : (
          <Paragraph>
            <>{t('ThereAreCurrentlyNoOnDemandEvents', { ns: 'trackmanEvents' })}</>
          </Paragraph>
        )}
      </div>
      <YouTubeVideoModal isModalOn={isModalOn} setIsModalOn={setIsModalOn} modalData={modalData} />
      <EventsFiltersPanel
        eventsList={tes.filteredOnDemandEventsList}
        filtersConfig={[{ key: 'premiumEvent', label: t('Subscription', { ns: 'trackmanEvents' }), options: filterConfig.premiumEvent }]}
        selectedFilters={tes.eventFilters}
        onFilterClick={onFilterClick}
        onClearFilters={onClearFilters}
        onApplyFilters={onApplyFilters}
        isFiltersVisible={isFiltersVisible}
        showFilters={setIsFiltersVisible}
      />
    </div>
  );
});

export default OnDemandRecordings;
